module.exports = __webpack_public_path__ + "img/toggle.f3764b1a.svg";